var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChartAverage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 12C9.70045 12 8.98535 9.9121 8.2937 7.89305C7.6382 5.97915 6.96 4 5.5 4C5.15905 4.02005 4.83179 4.14115 4.55991 4.34787C4.28804 4.55459 4.08386 4.83757 3.9734 5.16075L3.02565 4.8419C3.0508 4.7667 3.6609 3 5.5 3C7.67455 3 8.5061 5.42735 9.24 7.56895C9.84425 9.33335 10.415 11 11.5 11C11.841 10.98 12.1682 10.8589 12.4401 10.6521C12.712 10.4454 12.9161 10.1624 13.0266 9.83925L13.9743 10.1581C13.9492 10.2333 13.3391 12 11.5 12Z",
    fill: "#009D9A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 14V8.5H3V7.5H2V1H1V14C1 14.2652 1.10536 14.5196 1.29289 14.7071C1.48043 14.8946 1.73478 15 2 15H15V14H2Z",
    fill: "#009D9A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 7.5H4V8.5H5V7.5Z",
    fill: "#009D9A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 7.5H6V8.5H7V7.5Z",
    fill: "#009D9A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11 7.5H10V8.5H11V7.5Z",
    fill: "#009D9A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13 7.5H12V8.5H13V7.5Z",
    fill: "#009D9A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15 7.5H14V8.5H15V7.5Z",
    fill: "#009D9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartAverage);
export default __webpack_public_path__ + "static/media/chartAverage.dda6e9f5cb42305a21ea5e44d513e895.svg";
export { ForwardRef as ReactComponent };